import React, { Fragment } from 'react'
import { Col, Card, Row, Input, CardHeader, CardBody, FormGroup, Label, Button } from 'reactstrap';
import { useReportCancell } from '../../../hooks/Pbi/useReportCancell';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Chart } from 'primereact/chart';



export const IndexReportCancell = () => {

    const {
        setFilters, filters, cancellPatient, globalCancellFilter, chartDataCancell,
        chartOptionsCancell, countPatient,
        setGlobalCancellFilter, handleReport,
        loadingCancell, exportToExcelCancell, chartCancellRef,
        chartDataReason, chartOptionsReason, groupedByReason,
        handleViewCard, handleCloseCard, viewCard,

    } = useReportCancell();

    const formatAmount = (amount) => {
        return amount.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }


   const customBody = (rowData) => {
        return (
            <div className="nim-box">
                {rowData.nim}
            </div>
        );
    };

    const safeSum = (arr = []) =>
        Array.isArray(arr) && arr.length
            ? arr.reduce((a, b) => a + (Number(b) || 0), 0)
            : 0;

    const hasDataCancell =
        chartDataCancell?.labels?.length > 0 &&
        chartDataCancell?.datasets?.[0]?.data?.length > 0;

    const hasDataReason =
        groupedByReason &&
        Object.keys(groupedByReason).length > 0;





    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <div style={{ paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "111%", transformOrigin: "top left", textAlign: "center", height: "20%" }}>
                <Card style={{
                    marginBottom: '15px',
                    background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
                    border: 'none',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}>
                    <CardBody style={{ padding: '18px 25px' }}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <div style={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginRight: '15px'
                                }}>
                                    <img alt="flask" className="img-fluid text-info mr-2" src={require("../../../assets/images/laboratory-External/cash-money.svg")} style={{ width: "60px", height: "60px" }} />
                                </div>
                                <div>
                                    <h4 className="mb-1" style={{ color: '#fff', fontWeight: 700, fontSize: '20px', textAlign: "justify" }}>
                                        Reporte de Cancelaciones
                                    </h4>
                                    <small style={{ color: 'rgba(255,255,255,0.85)', fontSize: '13px' }}>
                                        <i className="fa fa-info-circle mr-1"></i>
                                        Análisis detallado de las cancelaciones de pacientes realizadas en el sistema.
                                    </small>
                                </div>
                            </div>

                        </div>
                    </CardBody>
                </Card>
                {
                    // * REPORT
                }
                <Card className='shadow-sm border height-equal pricingtable mb-0 pb-0' style={{ paddingTop: "1px", paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "113%", transformOrigin: "top left", textAlign: "center", height: "95%" }}>
                    <Col sm="12" className='pt-3'>
                        <Row>
                            <Col sm="2" className='p-l-0 p-r-0' style={{ textAlign: "left" }}>
                                <Card style={{
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                    border: 'none',
                                    height: '100%',
                                    borderRadius: '12px'
                                }}>
                                    <CardHeader style={{
                                        background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
                                        color: 'white',
                                        padding: '15px',
                                        borderRadius: '12px 12px 0 0'
                                    }}>
                                        <h6 className="mb-0" style={{ fontWeight: 700, fontSize: '15px' }}>
                                            <i className="fa fa-filter mr-2"></i>Filtros de Búsqueda
                                        </h6>
                                    </CardHeader>
                                    <CardBody style={{ padding: '20px' }}>
                                        <FormGroup>
                                            <Label className='f-w-600 label-report'>
                                                <i className="fa fa-calendar-alt mr-2" style={{ color: '#007bff' }}></i>Fecha de inicio
                                            </Label>
                                            <Input
                                                type='date'
                                                value={filters.dateStart}
                                                onChange={(e) => {
                                                    setFilters({ ...filters, dateStart: e.target.value })
                                                }}
                                                className='form-control'
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '1px solid #ddd',
                                                    padding: '10px',
                                                    fontSize: '13px'
                                                }}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label className='f-w-600 label-report'>
                                                <i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>Fecha de cierre
                                            </Label>
                                            <Input
                                                type='date'
                                                value={filters.dateEnd}
                                                onChange={(e) => {
                                                    setFilters({ ...filters, dateEnd: e.target.value })
                                                }}
                                                className='form-control'
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '1px solid #ddd',
                                                    padding: '10px',
                                                    fontSize: '13px'
                                                }}
                                            />
                                        </FormGroup>

                                        <br />
                                        <b>Acciones</b>
                                        <br /><br />
                                        <Button
                                            onClick={() => handleReport()}

                                            color="primary"
                                            block
                                            outline
                                            className="mb-3"
                                            style={{
                                                borderRadius: '10px',
                                                padding: '6px',
                                                fontSize: '14px',
                                                fontWeight: 600,
                                                borderWidth: '2px'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                        >
                                            Buscar
                                        </Button>

                                        {
                                            viewCard && <Button
                                                onClick={() => handleCloseCard()}

                                                color="dark"
                                                block
                                                outline
                                                className="mb-3"
                                                style={{
                                                    borderRadius: '10px',
                                                    padding: '6px',
                                                    fontSize: '14px',
                                                    fontWeight: 600,
                                                    borderWidth: '2px'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                            >
                                                <i className="fa fa-file-archive-o"></i>&ensp;
                                                Reporte
                                            </Button>
                                        }
                                        {
                                            !viewCard && <Button
                                                onClick={() => handleViewCard()}

                                                color="dark"
                                                block
                                                outline
                                                className="mb-3"
                                                style={{
                                                    borderRadius: '10px',
                                                    padding: '6px',
                                                    fontSize: '14px',
                                                    fontWeight: 600,
                                                    borderWidth: '2px'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                            >
                                                <i className="pi pi-chart-bar"></i>&ensp;
                                                Graficos
                                            </Button>

                                        }

                                        <Button
                                            color="success"
                                            onClick={() => exportToExcelCancell(cancellPatient)}
                                            block
                                            style={{
                                                borderRadius: '10px',
                                                padding: '6px',
                                                fontSize: '13px',
                                                fontWeight: 600,
                                                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                                transition: 'all 0.3s'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                            title="Descargar reporte"
                                        >
                                            <i className="pi pi-file-excel"></i>&ensp;
                                            Descargar
                                        </Button>

                                    </CardBody>


                                </Card>
                            </Col>

                            <Col sm="10">
                                <div style={{
                                    marginTop: '1px',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                    borderRadius: '12px',
                                    overflow: 'hidden',
                                    backgroundColor: '#fff'
                                }}>
                                    <Col sm="12" className='dark-mode-cancell'>
                                        {viewCard && (
                                            <Col sm="12">
                                                <Row className="gy-4">

                                                    <Col sm="6">
                                                        <div className="dashboard-card">

                                                            {/* Header */}
                                                            <div className="mb-3">
                                                                <h5 className="fw-bold d-flex align-items-center gap-2">
                                                                    <i className="fa fa-user-times text-primary" />
                                                                    Cancelaciones por Responsable
                                                                </h5>
                                                                <small className="text-muted">
                                                                    Resumen de cancelaciones aplicadas por usuario
                                                                </small>
                                                            </div>

                                                            <div className="d-flex justify-content-between mb-4">
                                                                <div>
                                                                    <small className="text-muted">Total cancelado</small>
                                                                    <h4 className="fw-bold text-danger">
                                                                        ${safeSum(chartDataCancell?.datasets?.[0]?.data).toFixed(2)}
                                                                    </h4>
                                                                </div>
                                                                <div>
                                                                    <small className="text-muted">Total eventos</small>
                                                                    <h4 className="fw-bold">
                                                                        {safeSum(chartDataCancell?.datasets?.[1]?.data)}
                                                                    </h4>
                                                                </div>
                                                            </div>

                                                            <Chart
                                                                type="bar"
                                                                data={chartDataCancell}
                                                                options={{
                                                                    ...chartOptionsCancell,
                                                                    plugins: {
                                                                        legend: { display: true },
                                                                        tooltip: { enabled: true }
                                                                    },
                                                                    scales: {
                                                                        x: {
                                                                            ticks: { display: false },
                                                                            grid: { display: false }
                                                                        },
                                                                        y: {
                                                                            grid: { color: '#e5e7eb' }
                                                                        }
                                                                    }
                                                                }}
                                                                ref={chartCancellRef}
                                                            />


                                                            <div className="table-responsive mt-4">
                                                                <table className="dashboard-table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Responsable</th>
                                                                            <th className="text-center">Veces</th>
                                                                            <th className="text-end">Total ($)</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {chartDataCancell?.labels?.map((name, index) => (
                                                                            <tr key={index}>
                                                                                <td className='dark-mode-td-table'>{name}</td>
                                                                                <td className="text-center dark-mode-td-table">
                                                                                    {chartDataCancell.datasets[1].data[index]}
                                                                                </td>
                                                                                <td className="text-end dark-mode-td-table">
                                                                                    ${chartDataCancell.datasets[0].data[index].toFixed(2)}
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>

                                                            </div>

                                                        </div>
                                                    </Col>

                                                    <Col sm="6">
                                                        <div className="dashboard-card">
                                                            <div className="mb-3">
                                                                <h5 className="fw-bold d-flex align-items-center gap-2">
                                                                    <i className="fa fa-ban text-danger" />
                                                                    Total Cancelado por Motivo
                                                                </h5>
                                                                <small className="text-muted">
                                                                    Distribución del monto cancelado por motivo
                                                                </small>
                                                            </div> <br /><br /><br /> <br />


                                                            <Chart
                                                                type="bar"
                                                                data={chartDataReason}
                                                                options={{
                                                                    ...chartOptionsReason,
                                                                    plugins: { legend: { display: false } },
                                                                    scales: {
                                                                        x: { grid: { display: false } },
                                                                        y: { grid: { color: '#e5e7eb' } }
                                                                    }
                                                                }}
                                                            />

                                                            <div className="table-responsive mt-4 pt-1">
                                                                <table className="dashboard-table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Motivo</th>
                                                                            <th className="text-center">Veces</th>
                                                                            <th className="text-end">Total ($)</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {Object.entries(groupedByReason).map(([reason, { totalAmount, count }]) => (
                                                                            <tr key={reason}>
                                                                                <td className='dark-mode-td-table'>{reason}</td>
                                                                                <td className="text-center dark-mode-td-table">{count}</td>
                                                                                <td className="text-end dark-mode-td-table">
                                                                                    ${totalAmount.toFixed(2)}
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>

                                                        </div>
                                                    </Col>

                                                </Row>
                                            </Col>
                                        )}

                                        {
                                            !viewCard && <div>
                                                <DataTable
                                                    className="data-table"
                                                    globalFilter={globalCancellFilter}
                                                    value={cancellPatient}
                                                    paginator
                                                    stripedRows
                                                    rows={8}
                                                    rowsPerPageOptions={[8, 10, 20, 30, 40, 50]}
                                                    emptyMessage={
                                                        <div className="text-center">
                                                            <img
                                                                src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                                style={{ width: "25%" }}
                                                                alt="Sin resultados"
                                                            />
                                                            <br />
                                                            <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>No se a generada ningún descuento.</p>
                                                        </div>
                                                    }
                                                    loading={loadingCancell}
                                                    loadingIcon="pi pi-spin pi-spinner"

                                                >
                                                    <Column
                                                        header="#"
                                                        body={(rowData, { rowIndex }) => rowIndex + 1}
                                                        style={{
                                                            textAlign: "center",
                                                            fontSize: "12px",
                                                            width: "9%",
                                                        }}
                                                        headerStyle={{
                                                            backgroundColor: "#1d5b83",
                                                            color: "#fff",
                                                            fontWeight: "bold",
                                                            fontSize: "12px",
                                                            padding: "12px",
                                                        }}
                                                    />
                                                    <Column
                                                        field="nim"
                                                        header="Nim"
                                                        sortable
                                                        headerStyle={{
                                                            backgroundColor: "#1d5b83",
                                                            color: "#fff",
                                                            fontWeight: "bold",
                                                            fontSize: "12px",
                                                            padding: "12px",
                                                        }}
                                                        style={{
                                                            fontSize: "12px",
                                                            textAlign: "center",
                                                            width: "10%",
                                                        }}
                                                        body={customBody}
                                                    />
                                                    <Column
                                                        field="branch"
                                                        header="Sucursal"
                                                        sortable
                                                        headerStyle={{
                                                            backgroundColor: "#1d5b83",
                                                            color: "#fff",
                                                            fontWeight: "bold",
                                                            fontSize: "12px",
                                                            padding: "5px",
                                                        }}
                                                        style={{
                                                            fontSize: "12px",
                                                            textAlign: "center",
                                                            width: "10%",
                                                        }}
                                                    />
                                                    <Column
                                                        field="name_patient"
                                                        header="Paciente"
                                                        sortable
                                                        headerStyle={{
                                                            backgroundColor: "#1d5b83",
                                                            color: "#fff",
                                                            fontWeight: "bold",
                                                            fontSize: "12px",
                                                            padding: "5px",
                                                        }}
                                                        style={{
                                                            fontSize: "12px",
                                                            textAlign: "center",
                                                            width: "10%",
                                                        }}
                                                    />


                                                    <Column
                                                        field="type"
                                                        header="Tipo de ingreso"
                                                        sortable
                                                        headerStyle={{
                                                            backgroundColor: "#1d5b83",
                                                            color: "#fff",
                                                            fontWeight: "bold",
                                                            fontSize: "12px",
                                                            padding: "5px",
                                                        }}
                                                        style={{
                                                            fontSize: "12px",
                                                            textAlign: "center",
                                                            width: "10%",
                                                        }}
                                                    />
                                                    <Column
                                                        field="amount"
                                                        header="Monto"
                                                        sortable
                                                        headerStyle={{
                                                            backgroundColor: "#1d5b83",
                                                            color: "#fff",
                                                            fontWeight: "bold",
                                                            fontSize: "12px",
                                                            padding: "5px",
                                                        }}
                                                        style={{
                                                            fontSize: "12px",
                                                            textAlign: "center",
                                                            width: "10%",
                                                        }}
                                                        body={(rowData) => `$${formatAmount(rowData.amount)}`}
                                                    />
                                                    <Column
                                                        field="reazon_cancellation"
                                                        header="Motivo de cancelación"
                                                        sortable
                                                        headerStyle={{
                                                            backgroundColor: "#1d5b83",
                                                            color: "#fff",
                                                            fontWeight: "bold",
                                                            fontSize: "12px",
                                                            padding: "5px",
                                                        }}
                                                        style={{
                                                            fontSize: "12px",
                                                            textAlign: "center",
                                                            width: "10%",
                                                        }}
                                                    />
                                                    <Column
                                                        field="user_autorized"
                                                        header="Responsable"
                                                        sortable
                                                        headerStyle={{
                                                            backgroundColor: "#1d5b83",
                                                            color: "#fff",
                                                            fontWeight: "bold",
                                                            fontSize: "12px",
                                                            padding: "5px",
                                                        }}
                                                        style={{
                                                            fontSize: "12px",
                                                            textAlign: "center",
                                                            width: "10%",
                                                        }}
                                                    />
                                                    <Column
                                                        field="date_cancellation"
                                                        header="Fecha de cancalación"
                                                        sortable
                                                        headerStyle={{
                                                            backgroundColor: "#1d5b83",
                                                            color: "#fff",
                                                            fontWeight: "bold",
                                                            fontSize: "12px",
                                                            padding: "5px",
                                                        }}
                                                        style={{
                                                            fontSize: "12px",
                                                            textAlign: "center",
                                                            width: "10%",
                                                        }}
                                                    />
                                                </DataTable>


                                            </div>
                                        }
                                    </Col>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Card>
            </div >
        </div >
    )
}

